"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = require("axios");
var helperFunctions_1 = require("./helperFunctions");
// Creates and sends a new OTP code
exports.requestNewCode = function (username, brand, messageType, IDMbaseurl) {
  return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          body = {
            'username': username
          };
          if (brand != null && brand != "" && messageType != null && messageType != "") {
            body = {
              'username': username,
              'brand': brand,
              'messageType': messageType
            };
          }
          return [4 /*yield*/, axios_1.default({
            url: IDMbaseurl + '/openidm/endpoint/createCode',
            method: 'post',
            headers: {
              'X-OpenIDM-Password': 'anonymous',
              'X-OpenIDM-Username': 'anonymous',
              'Content-Type': 'application/json'
            },
            data: body
          }).then(function (resp) {
            return handleCreateCodeResponse(resp);
          }).catch(function (err) {
            return handleCreateCodeError(err);
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var handleCreateCodeResponse = function (resp) {
  if (resp.data.code === 200) {
    // Expected behavior
    return {
      'code': 200,
      'resp': resp,
      'state': {
        'isResponseValid': null
      }
    };
  } else {
    // Unexpected behavior, successful response but with a code that's not 200
    return {
      'code': 400,
      'resp': resp,
      'state': {
        'isResponseValid': false
      }
    };
  }
};
var handleCreateCodeError = function (error) {
  return {
    'code': 400,
    'resp': error,
    'state': {
      'isResponseValid': false
    }
  };
};
// Validates OTP Code
exports.validateOTP = function (username, code, sourceApp, IDMbaseurl, AMbaseurl, name, realm, tree, signInType, finishAuth) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            url: IDMbaseurl + '/openidm/endpoint/validateCode',
            method: 'post',
            headers: {
              'X-OpenIDM-Password': 'anonymous',
              'X-OpenIDM-Username': 'anonymous',
              'Content-Type': 'application/json'
            },
            data: {
              'username': username,
              'code': code
            }
          }).then(function (response) {
            return handleValidateResponse(response, username, code, sourceApp, AMbaseurl, name, realm, tree, signInType, finishAuth);
          }).catch(function (error) {
            return handleValidateError(error);
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var handleValidateResponse = function (resp, username, code, sourceApp, baseURL, name, realm, tree, signInType, finishAuth) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(resp.data.code === 200)) return [3 /*break*/, 7];
          if (!finishAuth) return [3 /*break*/, 5];
          if (!(signInType === "PHONE" || signInType === "OTP")) return [3 /*break*/, 1];
          return [2 /*return*/, {
            'code': 200,
            'resp': resp,
            'type': 'phoneAuth'
          }];
        case 1:
          if (!(signInType === "EMAIL")) return [3 /*break*/, 3];
          return [4 /*yield*/, helperFunctions_1.finishPasswordAuthentication(username, sourceApp, baseURL, realm, tree, name, signInType)];
        case 2:
          return [2 /*return*/, _a.sent()];
        case 3:
          throw Error("Unsupported sign in type: " + signInType);
        case 4:
          return [3 /*break*/, 6];
        case 5:
          if (signInType === "PHONE" || signInType == "EMAIL") {
            return [2 /*return*/, {
              'code': 200,
              'resp': resp,
              'type': 'createPassword'
            }];
          } else {
            throw Error("Unsupported sign in type: " + signInType);
          }
          _a.label = 6;
        case 6:
          return [3 /*break*/, 8];
        case 7:
          if (resp.data.code === 401 && resp.data.message === "errorMessages.INVALID_CODE") {
            // Invalid code case, let the UI know
            return [2 /*return*/, {
              'code': 401,
              'resp': resp,
              'state': {
                'isCodeInvalid': true,
                'loading': false
              }
            }];
          } else {
            // Unexpected, non-erroneous response from IDM. This is invalid, so let the UI know.
            return [2 /*return*/, {
              'code': 400,
              'resp': resp,
              'state': {
                'isResponseValid': false,
                'loading': false
              }
            }];
          }
          _a.label = 8;
        case 8:
          return [2 /*return*/];
      }
    });
  });
};
var handleValidateError = function (error) {
  // set state loading false and responseValid false
  return {
    'code': 400,
    'resp': error,
    'state': {
      'isResponseValid': false,
      'loading': false
    }
  };
};
exports.login = function (username, password, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, callbacks, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          return [4 /*yield*/, exports.getCallbacks(url, headers, params)];
        case 1:
          callbacks = _a.sent();
          loginPayload = exports.processCallbacks(callbacks, username, password);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 2:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
exports.checkUsername = function (username, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, callbacks, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          return [4 /*yield*/, exports.getCallbacks(url, headers, params)];
        case 1:
          callbacks = _a.sent();
          loginPayload = exports.processCallbackSingle(callbacks, username);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 2:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
exports.checkPassword = function (password, callbacks, baseurl, realm, tree, name) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, params, loginPayload, loginResponse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = baseurl + '/' + name + '/json' + realm + '/authenticate';
          headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
          };
          params = {
            'authIndexType': 'service',
            'authIndexValue': tree
          };
          loginPayload = exports.processCallbackSingle(callbacks, password);
          return [4 /*yield*/, exports.sendLoginPayload(loginPayload, url, headers, params)];
        case 1:
          loginResponse = _a.sent();
          return [2 /*return*/, loginResponse];
      }
    });
  });
};
exports.getCallbacks = function (url, headers, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            headers: headers,
            method: 'post',
            params: params,
            url: url
          }).then(function (response) {
            return {
              response: response.data,
              status: response.status
            };
          }).catch(function (err) {
            return {
              response: err.response.data,
              status: err.response.status
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.processCallbacks = function (callbacks, username, password) {
  var loginPayload = callbacks.response;
  if (callbacks.status < 299) {
    loginPayload.callbacks[0].input[0].value = username;
    loginPayload.callbacks[1].input[0].value = password;
  }
  return loginPayload;
};
exports.processCallbackSingle = function (callbacks, value) {
  var loginPayload = callbacks.response;
  if (callbacks.status < 299) {
    loginPayload.callbacks[0].input[0].value = value;
  }
  return loginPayload;
};
exports.sendLoginPayload = function (loginPayload, url, headers, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, axios_1.default({
            data: loginPayload,
            headers: headers,
            method: 'post',
            params: params,
            url: url
          }).then(function (response) {
            return {
              response: response.data,
              status: response.status
            };
          }).catch(function (err) {
            return {
              response: err.response.data,
              status: err.response.status
            };
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.parseToken = function (token) {
  var tokenDeconstructed = token.split('*');
  return {
    'jwt': tokenDeconstructed[2],
    'original': token,
    'ssoToken': tokenDeconstructed[1] + '*'
  };
};